import React from "react";
const ParticipantStats = (props) => {
    return (React.createElement("div", { className: "d-flex pe-sm-3 pe-me-5 pe-2" },
        React.createElement("div", { className: "d-flex flex-column flex-grow-1" },
            React.createElement("p", { className: "tiny grey weight-600 border-bottom mb-0" }, "DISTANCE"),
            React.createElement("p", { className: "primary-color weight-700 m-0" },
                props.distance,
                " ",
                React.createElement("span", { className: "primary-color weight-300 small uppercase" }, props.distanceUnit.toUpperCase()))),
        React.createElement("div", { className: "d-flex flex-column ms-3" },
            React.createElement("p", { className: "tiny grey weight-600 border-bottom mb-0" }, props.isTeamList ? "CONTRIBUTION" : "PROGRESS"),
            React.createElement("p", { className: "primary-color weight-700 m-0" },
                props.completionPct,
                React.createElement("span", { className: "tiny align-text-top" }, "%")))));
};
export default React.memo(ParticipantStats);
